export default __webpack_public_path__ + "static/media/Metropolis-ExtraLightItalic.a86eca7f.otf";